import { useState } from "react";

function FaqItem({ question, answer, testId }) {
  const [open, setOpen] = useState(false);
  const answerId = `${testId}-answer`;
  const questionId = `${testId}-question`;

  return (
    <div className={`faq-item ${open ? 'open' : ''}`} data-testid={testId}>
      <h4 className="faq-question-heading">
        <button
          className="faq-question"
          onClick={() => setOpen(!open)}
          data-testid={`${testId}-toggle`}
          aria-expanded={open}
          aria-controls={answerId}
          id={questionId}
        >
          <span>{question}</span>
          <svg className={`faq-chevron ${open ? 'rotated' : ''}`} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>
        </button>
      </h4>
      <div
        id={answerId}
        className={`faq-answer ${open ? 'expanded' : ''}`}
        role="region"
        aria-labelledby={questionId}
        hidden={!open}
      >
        <p>{answer}</p>
      </div>
    </div>
  );
}

export default function FAQ({ t }) {
  return (
    <section id="faq" className="faq-section" data-testid="faq-section">
      <div className="section-inner">
        <div className="section-label fade-in">{t.faqLabel}</div>
        <h2 className="section-title fade-in">{t.faqTitle}</h2>
        <div className="faq-container">
          {t.faqCategories.map((cat, ci) => (
            <div key={ci} className="faq-category fade-in" style={{ transitionDelay: `${ci * 0.1}s` }}>
              <h3 className="faq-category-title">{cat.title}</h3>
              {cat.items.map((item, ii) => (
                <FaqItem key={ii} question={item.q} answer={item.a} testId={`faq-${ci}-${ii}`} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
